import { Loading } from 'element-ui';
let loadingInstance = null;
export const isLoading = function (isShow) {
    if (isShow === 1) {
        openLoading();
    } else {
        closeLoading();
    }
};
function openLoading() {
    loadingInstance = Loading.service({
        lock: true,
        spinner: 'el-icon-loading',
        text: '拼命加载中',
        background: 'rgba(0, 0, 0, 0.6)',
    });
}
function closeLoading() {
    if (loadingInstance) {
        loadingInstance.close();
    }
}
